import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  picker: {
    width: '100% !important',
    marginTop: '1rem',
  },
  addColor: {
    width: '100%',
    padding: '5px',
    marginTop: '5px',
    fontSize: '1rem',
  },
  colorNameInput: {
    width: '100%',
    height: '50px',
  },
}));

export default useStyles;
